(function (modules = {}) {
  Object.keys(modules).forEach(name => {
    if (typeof window[name] !== 'undefined') {
      throw new Error(
        `Unable to populate ${name} module since the namespace is already taken.`
      );
    }
    window[name] = modules[name];
  });
})(
  (function ({ jQuery: $ }) {
    /*! ===== 여기에 스크립트를 작성해 주세요. ===== */

    const mapOptions = {
      fullscreenControl: true,
      mapTypeControl: false,
      streetViewControl: false,
      zoomControl: true,
      zoom: 16,
    };

    const locations = [
      {
        id: 'seoul',
        title: '서울 본사',
        address1: '대한민국 서울특별시 강남구 테헤란로78길 12',
        position: { lat: 37.505382, lng: 127.055174 },
      },
      {
        id: 'taipei',
        title: '타이페이 사무소',
        address1:
          'Unit 2406, 24 Fl. Shanghai Times Square Office Building, 93 Hua',
        position: { lat: 25.030887, lng: 121.55852 },
      },
      {
        id: 'hochiminh',
        title: '호치민시 사무소',
        address1:
          'mPlaza Saigon, Unit 603, 6th Floor 39 Le Duan Street, District 1 Ho Chi Minh',
        position: { lat: 10.781433, lng: 106.700159 },
      },
      {
        id: 'jakarta',
        title: '자카르타 사무소',
        address1:
          'Sentral Senayan I(one), 5th Floor, Unit 105F Jl. Asia Afrika No. 8, Gelora, Tanahabang Central Jakarta, Jakarta 10270, Indonesia',
        position: { lat: -6.2247388, lng: 106.7972249 },
      },
      {
        id: 'singapore',
        title: '싱가포르 사무소',
        address1: '1 Temasek Avenue, Millenia Tower #29-01, Singapore 039192',
        position: { lat: 1.2927367, lng: 103.8603219 },
      },
    ];

    function createMap({ container, location = locations[0] }) {
      const $container = $(container);

      const map = new google.maps.Map($container.get(0), {
        ...mapOptions,
        center: location.position,
      });

      const markers = locations.map(({ position, title }) => {
        const marker = new google.maps.Marker({
          map,
          position,
          title,
        });
        return marker;
      });

      $container.data('map', map);
      $container.data('markers', markers);
    }

    function moveMap({ id: locationId, map }) {
      const mapInstance = $(map).data('map');
      const targetLocation = locations.find(({ id }) => id === locationId);

      if (!mapInstance) {
        throw new Error(`Google maps not initialized on: ${map}`);
      }
      if (!targetLocation) {
        throw new Error(`No location found of id: ${locationId}`);
      }

      mapInstance.setOptions({ center: targetLocation.position });
    }

    function addMapListeners({ container, map, panels, select }) {
      $(container).on('change', select, function () {
        const $this = $(this);
        const selectedValue = $this.val();

        // 다른 셀렉트 또는 라디오 버튼이 같은 value를 선택하도록 동기화
        $(select)
          .not($this)
          .each(function () {
            const $element = $(this);
            if ($element.is('select')) {
              $element.val(selectedValue);
            } else if ($element.val() === selectedValue) {
              $element.prop('checked', true);
            }
          });

        // 해당하는 패널로 이동
        $(panels)
          .removeClass('maps_panel_active')
          .filter(`[data-value="${selectedValue}"]`)
          .addClass('maps_panel_active');

        moveMap({ id: selectedValue, map });
      });
    }

    function initMap() {
      const container = '.js_maps';

      $(container).each(function () {
        const $container = $(this);
        const map = $container.data('map');
        const panels = $container.data('panel');
        const select = $container.data('select');

        createMap({ container: map });
        addMapListeners({ container, map, panels, select });
      });
    }

    /*! ===== window 네임스페이스에 추가할 모듈을 나열해 주세요. ===== */
    return {
      initMap,
    };
  })(
    (function (jQuery) {
      requireModule('jQuery', typeof jQuery === 'function');

      function requireModule(name, predicate) {
        if (!predicate) {
          throw new Error(
            `Unable to find ${name} module. Please make sure it is loaded before this script.`
          );
        }
      }

      return { jQuery };
    })(window.jQuery)
  )
);
